import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { LogService } from '../../shared/log/log.service';
import { ReservationCompareStore } from '../service/reservation-compare-store';

@Injectable()
export class RsvpDetailResolver implements Resolve<any> {

  constructor(
    private reservationCompareStore: ReservationCompareStore,
    private flashMessagesService: FlashMessagesService,
    private router: Router,
    private logService: LogService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let obs$: Observable<boolean>;

    const id = route.params['id'];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (eventPartyId) {
      this.reservationCompareStore.getRsvpsByParty(id, eventPartyId).subscribe(() => {
        obs$ = this.reservationCompareStore.isCompareListEmpty();

        obs$.take(1).subscribe(isEmpty => {
          if (!isEmpty) {
            this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);

            const path = route.url.map(urlSegment => urlSegment.path).join('/');
            this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
            this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
          } else {
            this.router.navigate(['event/' + id + '/' + eventPartyId + '/rsvp']).then(() => {
              this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
            });
          }
        });
      });
    } else {
      this.reservationCompareStore.getRsvps(id).subscribe(() => {
        obs$ = this.reservationCompareStore.isCompareListEmpty();

        obs$.take(1).subscribe(isEmpty => {
          if (!isEmpty) {
            this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);

            const path = route.url.map(urlSegment => urlSegment.path).join('/');
            this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
            this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
          } else {
            this.router.navigate(['event/' + id + '/rsvp']).then(() => {
              this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
            });
          }
        });
      });
    }

    return obs$;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-detail.resolver.ts